import { Typography, Container, Button, Box } from "@mui/material";

import { Link } from "react-router-dom";

import React from "react";

function Create(props) {
  return (
    <>
      <Container>
        <Typography variant="h1" component="h1">
          Create a new Tier List
        </Typography>
        <Box mb={2}>
          <Link to="/tierlist/new" style={{ textDecoration: "none" }}>
            <Button variant="contained" sx={{ textTransform: "none" }}>
              Create a new Tier List
            </Button>
          </Link>
        </Box>
        <Typography variant="h2" component="h2">
          Current Lists
        </Typography>
        <Box mb={2}>
          <Link to="/tierlist/drafts" style={{ textDecoration: "none" }}>
            <Button variant="contained" sx={{ textTransform: "none" }}>
              Look at my Tier List drafts
            </Button>
          </Link>
        </Box>
        <Box mb={2}>
          <Link to="/mytierlists" style={{ textDecoration: "none" }}>
            <Button variant="contained" sx={{ textTransform: "none" }}>
              Look at my Tier Lists
            </Button>
          </Link>
        </Box>
        <Typography variant="h2" component="h2">
          Templates
        </Typography>
        <Box mb={2}>
          <Link to="/topic/create" style={{ textDecoration: "none" }}>
            <Button variant="contained" sx={{ textTransform: "none" }}>
              Create a new Tier List Template
            </Button>
          </Link>
        </Box>
        <Box mb={2}>
          <Link to="/topic/mytemplates" style={{ textDecoration: "none" }}>
            <Button variant="contained" sx={{ textTransform: "none" }}>
              Look at my templates
            </Button>
          </Link>
        </Box>
      </Container>
    </>
  );
}

export default Create;
